import img1 from "../../assets/homePage/productImages/1.png";
import img2 from "../../assets/homePage/productImages/2.png";
import img3 from "../../assets/homePage/productImages/3.png";
import img4 from "../../assets/homePage/productImages/4.png";
import img5 from "../../assets/homePage/productImages/5.png";
import img6 from "../../assets/homePage/productImages/6.png";
import img7 from "../../assets/homePage/productImages/7.png";
import img8 from "../../assets/homePage/productImages/8.png";

export interface ProductProps {
  id: number;
  name: string;
  description: string;
  abv: string;
  ibu: string;
  image: string;
  reverse?: boolean;
}

export const products: ProductProps[] = [
  {
    id: 1,
    name: "Basmati Premium Lager",
    description:
      "A revolutionary craft beer made with premium basmati rice, our lager redefines brewing excellence. A crystal-clear pour with subtle rice aromatics and an exceptionally smooth finish. Perfect for any cuisine.",
    abv: "4.8%",
    ibu: "18",
    image: img1,
  },
  {
    id: 2,
    name: "Soul Surfer - Hefeweizen",
    description:
      "Crafted using traditional Hefeweizen methods with 50% wheat malt, our unfiltered ale delivers classic banana and clove notes. Naturally hazy with bright citrus undertones and a creamy mouthfeel - the perfect gateway to the world of craft beer.",
    abv: "5.2%",
    ibu: "15",
    image: img7,
  },
  {
    id: 3,
    name: "ESB",
    description:
      "A winter born and brewed, is one of the most decorated ales of its time, known for its balance and the interplay between malt and hop bitterness. English pale ale display earthy, herbal English-variety hop character. Medium to high hop bitterness, flavor and aroma should be evident.",
    abv: "5%",
    ibu: "25",
    image: img2,
  },
  {
    id: 4,
    name: "Belgian Wit",
    description:
      "A delightful brew, our Wit is a traditional Belgian wheat beer lightly spiced with coriander, orange peel. Light and crisp up front, it features smooth bready flavors, bright citrus notes, and spicy fruit accents from the coriander and traditional wit yeast. Sessionable to its core, Belgian Wit epitomizes the term Summer Beer",
    abv: "5.5%",
    ibu: "13",
    image: img3,
  },
  {
    id: 5,
    name: "Belgian Tripel",
    description:
      "Belgian triple is a strong ale, a fruity flavor beer perfect for a summer evening. Hints of apple hit the nose with every sip and ends with a crisp strong flavor on the tongue. This beer too supreme for tastebuds.",
    abv: "8%",
    ibu: "22",
    image: img4,
  },
  {
    id: 6,
    name: "KÖLSCH",
    description:
      "A pleasant, delicate fruity aroma from fermentation with clean, crisp, delicately balanced beer with a very subtle hop character. Its subdued maltiness throughout leads into a pleasantly well-attenuated and refreshing finish.",
    abv: "4.2%",
    ibu: "15",
    image: img5,
  },
  {
    id: 7,
    name: "Bangalore Daze",
    description:
      "The perfect blend of citrus hops and pale ale malts combined to create this well-balanced, crisp and delicious IPA. Each sip gives rise to the delicate flavors of pine and honey that is sure to leave you wanting more.",
    abv: "5.5%",
    ibu: "25",
    image: img6,
  },
  {
    id: 8,
    name: "Black Pearl",
    description:
      "The silky, smooth, almost seductive feel of this dark beer, enhanced with a heady combination of chocolate, coffee, caramel and lactose gives rise to the perfect blend of this mildly sweet stout. This complex combination packs quite a punch of flavors.",
    abv: "5.5%",
    ibu: "25",
    image: img8,
  },
];
